export enum TravelAnalysisMessages {
  pageTitle = "travelAnalysis.pageTitle",
  filterButton = "travelAnalysis.filterButton",
  loading = "travelAnalysis.loading",
  totalAnalyzed = "travelAnalysis.totalAnalyzed",
  successfulTrips = "travelAnalysis.successfulTrips",
  successRate = "travelAnalysis.successRate",
  alertsDetected = "travelAnalysis.alertsDetected",
  target = "travelAnalysis.target",
  alertDistributionTitle = "travelAnalysis.alertDistributionTitle",
  noAlertsInPeriod = "travelAnalysis.noAlertsInPeriod",
  successRatioTitle = "travelAnalysis.successRatioTitle",
  noData = "travelAnalysis.noData",
  success = "travelAnalysis.success",
  alerts = "travelAnalysis.alerts",
  efficiency = "travelAnalysis.efficiency",
  geographicMonitoringTitle = "travelAnalysis.geographicMonitoringTitle",
  geographicMonitoringSubtitle = "travelAnalysis.geographicMonitoringSubtitle",
  noGeographicData = "travelAnalysis.noGeographicData",
  activeVehicles = "travelAnalysis.activeVehicles",
  activeAlerts = "travelAnalysis.activeAlerts",
  dashboardSubtitle = "travelAnalysis.dashboardSubtitle",
  percentOfTotal = "travelAnalysis.percentOfTotal",
  alertsListTitle = "travelAnalysis.alertsListTitle",
  columnVehicle = "travelAnalysis.columnVehicle",
  columnAlertType = "travelAnalysis.columnAlertType",
  columnOrigin = "travelAnalysis.columnOrigin",
  columnDestination = "travelAnalysis.columnDestination",
  columnDate = "travelAnalysis.columnDate",
  noAlertsFound = "travelAnalysis.noAlertsFound",
  loadMore = "travelAnalysis.loadMore",
  close = "travelAnalysis.close",
  tripsUnit = "travelAnalysis.tripsUnit",
  columnNumDoc = "travelAnalysis.columnNumDoc",
  columnActions = "travelAnalysis.columnActions",
  viewAlertDetails = "travelAnalysis.viewAlertDetails",
  viewTravel = "travelAnalysis.viewTravel",
  alertDetailsTitle = "travelAnalysis.alertDetailsTitle",
  loadingTravel = "travelAnalysis.loadingTravel",
  // Metadata labels — CAN Data Stall
  metaSource = "travelAnalysis.metaSource",
  metaStallType = "travelAnalysis.metaStallType",
  metaThreshold = "travelAnalysis.metaThreshold",
  metaStalledFields = "travelAnalysis.metaStalledFields",
  metaTotalCanPackets = "travelAnalysis.metaTotalCanPackets",
  // Cross Day Cycle
  metaStartDate = "travelAnalysis.metaStartDate",
  metaFinishDate = "travelAnalysis.metaFinishDate",
  metaStartDay = "travelAnalysis.metaStartDay",
  metaFinishDay = "travelAnalysis.metaFinishDay",
  metaDurationHours = "travelAnalysis.metaDurationHours",
  // False Positive Discharge
  metaTotalDischargeCommands = "travelAnalysis.metaTotalDischargeCommands",
  metaCoveredCommands = "travelAnalysis.metaCoveredCommands",
  metaOrphanCommands = "travelAnalysis.metaOrphanCommands",
  metaOrphanRatio = "travelAnalysis.metaOrphanRatio",
  metaCoveredRanges = "travelAnalysis.metaCoveredRanges",
  // GPRS Connection Instability
  metaTotalPackets = "travelAnalysis.metaTotalPackets",
  metaMemoryCommands = "travelAnalysis.metaMemoryCommands",
  metaEffectiveRealtimeCommands = "travelAnalysis.metaEffectiveRealtimeCommands",
  metaRealtimeCommands = "travelAnalysis.metaRealtimeCommands",
  metaMemoryRatio = "travelAnalysis.metaMemoryRatio",
  metaThresholdPercent = "travelAnalysis.metaThresholdPercent",
  metaEffectiveRealtimeThresholdSeconds = "travelAnalysis.metaEffectiveRealtimeThresholdSeconds",
  metaAvgDelaySeconds = "travelAnalysis.metaAvgDelaySeconds",
  metaMaxDelaySeconds = "travelAnalysis.metaMaxDelaySeconds",
  // GPS Positioning Failure
  metaTotalGpsPackets = "travelAnalysis.metaTotalGpsPackets",
  metaInvalidFixCount = "travelAnalysis.metaInvalidFixCount",
  metaInvalidRatio = "travelAnalysis.metaInvalidRatio",
  metaAvgSatellites = "travelAnalysis.metaAvgSatellites",
  // Hardware Command Deficit
  metaPacketCount = "travelAnalysis.metaPacketCount",
  metaExpectedPackets = "travelAnalysis.metaExpectedPackets",
  metaMinimumRequired = "travelAnalysis.metaMinimumRequired",
  metaDeficitPercent = "travelAnalysis.metaDeficitPercent",
  metaRatePerMinute = "travelAnalysis.metaRatePerMinute",
  metaTravelDurationMinutes = "travelAnalysis.metaTravelDurationMinutes",
  // Logistics Flow Inconsistency
  metaRequiredStates = "travelAnalysis.metaRequiredStates",
  metaActualStates = "travelAnalysis.metaActualStates",
  metaMissingStates = "travelAnalysis.metaMissingStates",
  metaMissingCount = "travelAnalysis.metaMissingCount",
  metaTotalStates = "travelAnalysis.metaTotalStates",
  metaNumDoc = "travelAnalysis.metaNumDoc",
  // Sensor Command Deficit (IDLE)
  metaIgnitionOnCount = "travelAnalysis.metaIgnitionOnCount",
  metaIdleCount = "travelAnalysis.metaIdleCount",
  metaLoadingCount = "travelAnalysis.metaLoadingCount",
  metaUnloadingCount = "travelAnalysis.metaUnloadingCount",
  metaIdleRatio = "travelAnalysis.metaIdleRatio",
  // Grouped success charts
  successByDayTitle = "travelAnalysis.successByDayTitle",
  successByPlantTitle = "travelAnalysis.successByPlantTitle",
  successByRegionalTitle = "travelAnalysis.successByRegionalTitle",
  averageLine = "travelAnalysis.averageLine",
  noGroupedData = "travelAnalysis.noGroupedData",
  coordinateViewTitle = "travelAnalysis.coordinateViewTitle",
  coordinateViewVehicle = "travelAnalysis.coordinateViewVehicle",
  coordinateViewNF = "travelAnalysis.coordinateViewNF",
  coordinateViewGeneral = "travelAnalysis.coordinateViewGeneral",
  coordinateViewContent = "travelAnalysis.coordinateViewContent",
  coordinateViewResult = "travelAnalysis.coordinateViewResult",
  coordinateViewGeneralData = "travelAnalysis.coordinateViewGeneralData",
  coordinateViewCommandContent = "travelAnalysis.coordinateViewCommandContent",
  coordinateViewProcessingResult = "travelAnalysis.coordinateViewProcessingResult",
  coordinateViewNoData = "travelAnalysis.coordinateViewNoData",
  coordinateViewField = "travelAnalysis.coordinateViewField",
  coordinateViewValue = "travelAnalysis.coordinateViewValue",
  // Alert glossary (help drawer)
  glossaryButtonLabel = "travelAnalysis.glossaryButtonLabel",
  glossaryDrawerTitle = "travelAnalysis.glossaryDrawerTitle",
  glossaryIntroTitle = "travelAnalysis.glossaryIntroTitle",
  glossaryIntroText = "travelAnalysis.glossaryIntroText",
  glossaryWhenLabel = "travelAnalysis.glossaryWhenLabel",
  glossaryAppliesLabel = "travelAnalysis.glossaryAppliesLabel",
  glossaryMetadataLabel = "travelAnalysis.glossaryMetadataLabel",
  glossaryAppliesAll = "travelAnalysis.glossaryAppliesAll",
  glossaryAppliesMixerPump = "travelAnalysis.glossaryAppliesMixerPump",
  glossaryAppliesMixer = "travelAnalysis.glossaryAppliesMixer",
  glossaryAppliesMixerDoc = "travelAnalysis.glossaryAppliesMixerDoc",
  // Glossary — GPRS Connection Instability
  glossaryGprsTitle = "travelAnalysis.glossaryGprsTitle",
  glossaryGprsDesc = "travelAnalysis.glossaryGprsDesc",
  glossaryGprsWhen = "travelAnalysis.glossaryGprsWhen",
  glossaryGprsMeta = "travelAnalysis.glossaryGprsMeta",
  // Glossary — GPS Positioning Failure
  glossaryGpsTitle = "travelAnalysis.glossaryGpsTitle",
  glossaryGpsDesc = "travelAnalysis.glossaryGpsDesc",
  glossaryGpsWhen = "travelAnalysis.glossaryGpsWhen",
  glossaryGpsMeta = "travelAnalysis.glossaryGpsMeta",
  // Glossary — Cross Day Cycle
  glossaryCrossDayTitle = "travelAnalysis.glossaryCrossDayTitle",
  glossaryCrossDayDesc = "travelAnalysis.glossaryCrossDayDesc",
  glossaryCrossDayWhen = "travelAnalysis.glossaryCrossDayWhen",
  glossaryCrossDayMeta = "travelAnalysis.glossaryCrossDayMeta",
  // Glossary — Hardware Command Deficit
  glossaryHwDeficitTitle = "travelAnalysis.glossaryHwDeficitTitle",
  glossaryHwDeficitDesc = "travelAnalysis.glossaryHwDeficitDesc",
  glossaryHwDeficitWhen = "travelAnalysis.glossaryHwDeficitWhen",
  glossaryHwDeficitMeta = "travelAnalysis.glossaryHwDeficitMeta",
  // Glossary — Sensor Command Deficit (IDLE)
  glossarySensorIdleTitle = "travelAnalysis.glossarySensorIdleTitle",
  glossarySensorIdleDesc = "travelAnalysis.glossarySensorIdleDesc",
  glossarySensorIdleWhen = "travelAnalysis.glossarySensorIdleWhen",
  glossarySensorIdleMeta = "travelAnalysis.glossarySensorIdleMeta",
  // Glossary — Logistics Flow Inconsistency
  glossaryLogisticsTitle = "travelAnalysis.glossaryLogisticsTitle",
  glossaryLogisticsDesc = "travelAnalysis.glossaryLogisticsDesc",
  glossaryLogisticsWhen = "travelAnalysis.glossaryLogisticsWhen",
  glossaryLogisticsMeta = "travelAnalysis.glossaryLogisticsMeta",
  // Glossary — CAN Data Stall
  glossaryCanStallTitle = "travelAnalysis.glossaryCanStallTitle",
  glossaryCanStallDesc = "travelAnalysis.glossaryCanStallDesc",
  glossaryCanStallWhen = "travelAnalysis.glossaryCanStallWhen",
  glossaryCanStallMeta = "travelAnalysis.glossaryCanStallMeta",
  // Glossary — False Positive Discharge
  glossaryFalseDischargeTitle = "travelAnalysis.glossaryFalseDischargeTitle",
  glossaryFalseDischargeDesc = "travelAnalysis.glossaryFalseDischargeDesc",
  glossaryFalseDischargeWhen = "travelAnalysis.glossaryFalseDischargeWhen",
  glossaryFalseDischargeMeta = "travelAnalysis.glossaryFalseDischargeMeta",
  // Travel cycle analysis
  cycleKpiTicketTravels = "travelAnalysis.cycleKpiTicketTravels",
  cycleKpiComplete = "travelAnalysis.cycleKpiComplete",
  cycleKpiCompleteSub = "travelAnalysis.cycleKpiCompleteSub",
  cycleKpiFailed = "travelAnalysis.cycleKpiFailed",
  cycleKpiSeeCauses = "travelAnalysis.cycleKpiSeeCauses",
  cycleKpiHardware = "travelAnalysis.cycleKpiHardware",
  cycleKpiSensors = "travelAnalysis.cycleKpiSensors",
  cycleKpiTrackers = "travelAnalysis.cycleKpiTrackers",
  cycleKpiVehicles = "travelAnalysis.cycleKpiVehicles",
  cycleImpactTitle = "travelAnalysis.cycleImpactTitle",
  cycleImpactHint = "travelAnalysis.cycleImpactHint",
  cycleNoFailures = "travelAnalysis.cycleNoFailures",
  groupEquipment = "travelAnalysis.groupEquipment",
  groupEquipmentDesc = "travelAnalysis.groupEquipmentDesc",
  groupRegistration = "travelAnalysis.groupRegistration",
  groupRegistrationDesc = "travelAnalysis.groupRegistrationDesc",
  groupRoutine = "travelAnalysis.groupRoutine",
  groupRoutineDesc = "travelAnalysis.groupRoutineDesc",
  groupOthers = "travelAnalysis.groupOthers",
  groupOthersDesc = "travelAnalysis.groupOthersDesc",
  outcomeComplete = "travelAnalysis.outcomeComplete",
  outcomeSensorStopped = "travelAnalysis.outcomeSensorStopped",
  outcomeSensorStoppedDesc = "travelAnalysis.outcomeSensorStoppedDesc",
  outcomeSensorStoppedAction = "travelAnalysis.outcomeSensorStoppedAction",
  outcomeSensorIntermittent = "travelAnalysis.outcomeSensorIntermittent",
  outcomeSensorIntermittentDesc = "travelAnalysis.outcomeSensorIntermittentDesc",
  outcomeSensorIntermittentAction = "travelAnalysis.outcomeSensorIntermittentAction",
  outcomeDischargeOneOff = "travelAnalysis.outcomeDischargeOneOff",
  outcomeDischargeOneOffDesc = "travelAnalysis.outcomeDischargeOneOffDesc",
  outcomeDischargeOneOffAction = "travelAnalysis.outcomeDischargeOneOffAction",
  outcomeTrackerWithoutSignal = "travelAnalysis.outcomeTrackerWithoutSignal",
  outcomeTrackerWithoutSignalDesc = "travelAnalysis.outcomeTrackerWithoutSignalDesc",
  outcomeTrackerWithoutSignalAction = "travelAnalysis.outcomeTrackerWithoutSignalAction",
  outcomeInactivePlant = "travelAnalysis.outcomeInactivePlant",
  outcomeInactivePlantDesc = "travelAnalysis.outcomeInactivePlantDesc",
  outcomeInactivePlantAction = "travelAnalysis.outcomeInactivePlantAction",
  outcomeJobsiteNotDetected = "travelAnalysis.outcomeJobsiteNotDetected",
  outcomeJobsiteNotDetectedDesc = "travelAnalysis.outcomeJobsiteNotDetectedDesc",
  outcomeJobsiteNotDetectedAction = "travelAnalysis.outcomeJobsiteNotDetectedAction",
  outcomeDischargeOutsideJobsite = "travelAnalysis.outcomeDischargeOutsideJobsite",
  outcomeDischargeOutsideJobsiteDesc = "travelAnalysis.outcomeDischargeOutsideJobsiteDesc",
  outcomeDischargeOutsideJobsiteAction = "travelAnalysis.outcomeDischargeOutsideJobsiteAction",
  outcomeJobsiteNextToPlant = "travelAnalysis.outcomeJobsiteNextToPlant",
  outcomeJobsiteNextToPlantDesc = "travelAnalysis.outcomeJobsiteNextToPlantDesc",
  outcomeJobsiteNextToPlantAction = "travelAnalysis.outcomeJobsiteNextToPlantAction",
  outcomeShortPlantExit = "travelAnalysis.outcomeShortPlantExit",
  outcomeShortPlantExitDesc = "travelAnalysis.outcomeShortPlantExitDesc",
  outcomeShortPlantExitAction = "travelAnalysis.outcomeShortPlantExitAction",
  outcomeReplacedTicket = "travelAnalysis.outcomeReplacedTicket",
  outcomeReplacedTicketDesc = "travelAnalysis.outcomeReplacedTicketDesc",
  outcomeReplacedTicketAction = "travelAnalysis.outcomeReplacedTicketAction",
  outcomeTwoTickets = "travelAnalysis.outcomeTwoTickets",
  outcomeTwoTicketsDesc = "travelAnalysis.outcomeTwoTicketsDesc",
  outcomeTwoTicketsAction = "travelAnalysis.outcomeTwoTicketsAction",
  outcomeIntegrationNotSent = "travelAnalysis.outcomeIntegrationNotSent",
  outcomeIntegrationNotSentDesc = "travelAnalysis.outcomeIntegrationNotSentDesc",
  outcomeIntegrationNotSentAction = "travelAnalysis.outcomeIntegrationNotSentAction",
  outcomeOther = "travelAnalysis.outcomeOther",
  outcomeOtherDesc = "travelAnalysis.outcomeOtherDesc",
  outcomeOtherAction = "travelAnalysis.outcomeOtherAction",
  cyclePlacesByRegional = "travelAnalysis.cyclePlacesByRegional",
  cyclePlacesByPlant = "travelAnalysis.cyclePlacesByPlant",
  cyclePlacesHint = "travelAnalysis.cyclePlacesHint",
  toggleRegional = "travelAnalysis.toggleRegional",
  togglePlant = "travelAnalysis.togglePlant",
  toggleTable = "travelAnalysis.toggleTable",
  toggleChart = "travelAnalysis.toggleChart",
  columnRegional = "travelAnalysis.columnRegional",
  columnPlant = "travelAnalysis.columnPlant",
  columnTravels = "travelAnalysis.columnTravels",
  columnCycleComplete = "travelAnalysis.columnCycleComplete",
  columnFailuresByType = "travelAnalysis.columnFailuresByType",
  columnTopCause = "travelAnalysis.columnTopCause",
  fewTravels = "travelAnalysis.fewTravels",
  ofTravels = "travelAnalysis.ofTravels",
  noRegional = "travelAnalysis.noRegional",
  hardwareTitle = "travelAnalysis.hardwareTitle",
  hardwareHint = "travelAnalysis.hardwareHint",
  hwAll = "travelAnalysis.hwAll",
  hwSensorStopped = "travelAnalysis.hwSensorStopped",
  hwSensorIntermittent = "travelAnalysis.hwSensorIntermittent",
  hwTracker = "travelAnalysis.hwTracker",
  columnProblem = "travelAnalysis.columnProblem",
  columnDischarges = "travelAnalysis.columnDischarges",
  columnFailedTravels = "travelAnalysis.columnFailedTravels",
  columnLastUnload = "travelAnalysis.columnLastUnload",
  columnLastSignal = "travelAnalysis.columnLastSignal",
  wordOf = "travelAnalysis.wordOf",
  hwSensorShort = "travelAnalysis.hwSensorShort",
  hwTrackerShort = "travelAnalysis.hwTrackerShort",
  noHardware = "travelAnalysis.noHardware",
  cycleDrilldownTitle = "travelAnalysis.cycleDrilldownTitle",
  columnMainPlant = "travelAnalysis.columnMainPlant",
  columnTravelsWithCause = "travelAnalysis.columnTravelsWithCause",
  columnShareOfVehicle = "travelAnalysis.columnShareOfVehicle",
  columnRegisteredStates = "travelAnalysis.columnRegisteredStates",
  columnCause = "travelAnalysis.columnCause",
  stateRegistered = "travelAnalysis.stateRegistered",
  stateNotRegistered = "travelAnalysis.stateNotRegistered",
  telemetryTitle = "travelAnalysis.telemetryTitle",
  telemetryHint = "travelAnalysis.telemetryHint",
  glossaryCyclesSection = "travelAnalysis.glossaryCyclesSection",
  glossaryAlertsSection = "travelAnalysis.glossaryAlertsSection",
  glossaryWhatToDo = "travelAnalysis.glossaryWhatToDo",
  glossarySensorHealth = "travelAnalysis.glossarySensorHealth",
  dailyTitle = "travelAnalysis.dailyTitle",
  dailyHint = "travelAnalysis.dailyHint",
  movingAverage = "travelAnalysis.movingAverage",
  periodAverage = "travelAnalysis.periodAverage",
  averageShort = "travelAnalysis.averageShort",
  generalLine = "travelAnalysis.generalLine",
  selectedPlaces = "travelAnalysis.selectedPlaces",
  chartNotePlaces = "travelAnalysis.chartNotePlaces",
  backTo = "travelAnalysis.backTo",
  tileTravels = "travelAnalysis.tileTravels",
  tileShareOfFilter = "travelAnalysis.tileShareOfFilter",
  tileVehicles = "travelAnalysis.tileVehicles",
  tileGroup = "travelAnalysis.tileGroup",
  whatItIs = "travelAnalysis.whatItIs",
  byRegional = "travelAnalysis.byRegional",
  byPlant = "travelAnalysis.byPlant",
  vehiclesWithCause = "travelAnalysis.vehiclesWithCause",
  tileTravelsInPeriod = "travelAnalysis.tileTravelsInPeriod",
  tileWithFailure = "travelAnalysis.tileWithFailure",
  tileWithThisCause = "travelAnalysis.tileWithThisCause",
  tilePlant = "travelAnalysis.tilePlant",
  tileSensor = "travelAnalysis.tileSensor",
  sensorStopped = "travelAnalysis.sensorStopped",
  sensorIntermittent = "travelAnalysis.sensorIntermittent",
  sensorOk = "travelAnalysis.sensorOk",
  sensorDetail = "travelAnalysis.sensorDetail",
  failuresByCause = "travelAnalysis.failuresByCause",
  failedTravelsCount = "travelAnalysis.failedTravelsCount",
  columnDetails = "travelAnalysis.columnDetails",
  stateOnTheWay = "travelAnalysis.stateOnTheWay",
  stateJobsite = "travelAnalysis.stateJobsite",
  stateDischarging = "travelAnalysis.stateDischarging",
  stateReturning = "travelAnalysis.stateReturning",
  statePlant = "travelAnalysis.statePlant",
  glossaryCausesCount = "travelAnalysis.glossaryCausesCount",
  glossaryAlertsCount = "travelAnalysis.glossaryAlertsCount"
}

export type TranslationTravelAnalysisMessages = {
  [key in TravelAnalysisMessages]: string;
}
